var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUiUXicon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543",
    transform: "translate(-199 -829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541",
    transform: "translate(2 39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    transform: "translate(197 790)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-paint-brush",
    "data-name": "Icon awesome-paint-brush",
    d: "M5.871,10.875a3.558,3.558,0,0,0-3.417,2.542.537.537,0,0,1-.513.351c-.391,0-1.6-.973-1.942-1.208C0,15.455,1.333,18,4.5,18,7.166,18,9,16.461,9,13.774a3.046,3.046,0,0,0-.034-.321L5.871,10.875ZM16.1,0a2.147,2.147,0,0,0-1.414.578C7.5,7,6.75,7.149,6.75,9.038A3.255,3.255,0,0,0,7.056,10.4L9.3,12.268a3.235,3.235,0,0,0,.787.107c2.184,0,3.449-1.6,7.423-9.016A3.617,3.617,0,0,0,18,1.742,1.831,1.831,0,0,0,16.1,0Z",
    transform: "translate(205.001 835)",
    fill: "#8f6f6f"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiUXicon);
export default __webpack_public_path__ + "static/media/uiUXicon.45ce564353f8dfa6ebfa66026fbad09d.svg";
export { ForwardRef as ReactComponent };